import { Controller } from "stimulus"
export default class extends Controller {
  static targets = [ "inputTrigger", "input"]

  duplicate() {
    document.querySelector(event.currentTarget.dataset.target).checked = event.currentTarget.checked;
  }
}
